import { addressInfoDisplayStyles } from "@tKgpco/Components/WOR/WORAddressInfoDisplay";
import { css } from "styled-components";

Object.assign(addressInfoDisplayStyles, {
    wrapper: {
        css: css`
            font-style: normal;
            font-size: 13px;
            font-weight: 500;
        `,
    },
});
